import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import gql from 'graphql-tag';

// GraphQL queries
const INVITATIONS_QUERY = gql`
  query Invitations {
    invitations {
      id
      uuid
    }
  }
`;

const USER_WHITELABELS_SHORTD_QUERY = gql`
  query WhiteLabelsShort($owner_uuid: ID!) {
    whiteLabels(owner_uuid: $owner_uuid) {
      uuid
      name
      owner {
        uuid
      }
    }
  }
`;

const ME_QUERY = gql`
  query Me {
    me {
      uuid
    }
  }
`;

// Создаем Apollo клиент для проверки
const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:8000/graphql',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('auth-token')}`
    }
  });

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache()
  });
};

export const checkQuizNeeded = async () => {
  try {
    const client = createApolloClient();
    
    // Получаем данные пользователя
    const { data: meData } = await client.query({
      query: ME_QUERY,
      fetchPolicy: 'network-only'
    });

    if (!meData.me) {
      return { needed: false, redirect: '/login' };
    }

    const userUuid = meData.me.uuid;

    // Проверяем invitations
    const { data: invitationsData } = await client.query({
      query: INVITATIONS_QUERY,
      fetchPolicy: 'network-only'
    });

    // Проверяем whitelabels
    const { data: whiteLabelsData } = await client.query({
      query: USER_WHITELABELS_SHORTD_QUERY,
      variables: { owner_uuid: userUuid },
      fetchPolicy: 'network-only'
    });

    // Если есть whitelabels, квиз не нужен
    if (whiteLabelsData.whiteLabels && whiteLabelsData.whiteLabels.length > 0) {
      return { needed: false, redirect: '/dashboard' };
    }

    // Если есть invitations, квиз не нужен
    if (invitationsData.invitations && invitationsData.invitations.length > 0) {
      return { needed: false, redirect: '/dashboard' };
    }

    // Если нет ни whitelabels, ни invitations, квиз нужен
    return { needed: true, redirect: null };

  } catch (error) {
    console.error('Error checking quiz:', error);
    // В случае ошибки, считаем что квиз не нужен и перенаправляем на dashboard
    return { needed: false, redirect: '/dashboard' };
  }
};
